export type TodoItem = {
  task: string;
  tags: string[];
  completed: boolean;
  description?: string;
  example_data?: Record<string, unknown>;
};

export const todos: TodoItem[] = [
  {
    task: "Dotazovani nad Id pizz",
    tags: ["be"],
    completed: false,
  },
  {
    task: "/orders cursor",
    tags: ["be"],
    completed: false,
  },
  {
    task: "Swager ",
    tags: ["be"],
    completed: false,
  },
  {
    task: "Endpoint for pizza types",
    tags: ["be"],
    description: "Pizza type / Name + jednotlive ingredience",
    completed: false,
  },
  {
    task: "Vycentrovani + cropnuti layeru",
    tags: ["be"],
    completed: false,
  },
  {
    task: "Integrace modelu od pavla",
    tags: ["be"],
    completed: false,
  },
  {
    task: "Date time filter",
    tags: ["fe"],
    example_data: {
      sort: "sent_at",
      order: "asc",
      filters: {
        sent_at: {
          $gte: "2025-04-13T18:46:47.052Z",
          $lte: "2025-04-15T18:46:47.052Z",
        },
      },
    },
    completed: false,
  },
  {
    task: "Visualize boudning boxes from object detector",
    tags: ["fe"],
    completed: false,
  },
  {
    task: "Layers authorization",
    tags: ["fe"],
    completed: false,
  },
  {
    task: "Create badge / tag for pizza componets",
    tags: ["fe"],
    completed: false,
  },
  {
    task: "Integrate firebase realtime database",
    tags: ["fe"],
    description: "https://firebase.google.com/docs/database/web/start",
    completed: false,
  },
  {
    task: "migrate to react 19",
    tags: ["fe"],
    description: "https://react.dev/blog/2024/04/25/react-19-upgrade-guide",
    completed: false,
  },
];